<div class="pop-up">
  <div class="error-img">&nbsp;</div>

  <p class="not-title">{{ "plp.noResultFound" | cxTranslate }}</p>

  <p class="pnf-descriprion">
    {{ "plp.incorrectSearch" | cxTranslate }} <br />{{ "plp.brodenSearch" | cxTranslate }}<br />

    {{ "plp.browseProduct" | cxTranslate }}<br />

    {{ "plp.consultBH" | cxTranslate }}<br />
  </p>

  <h3 class="or">{{ "plp.or" | cxTranslate }}</h3>

  <button class="vs-primary-btn" (click)="gotoRequestQuote()">
    {{ "plp.requestQuoteBtn" | cxTranslate }}
  </button>
</div>
